const DIRECTION_TYPES = {
  Features: 'horizontal',
  VerticalFeatures: 'vertical',
  Swimlane: 'swimlane',
}

const CMS_COMPONENT_CONTAINER_DEFAULT_MARGIN = 10

export {
  DIRECTION_TYPES,
  CMS_COMPONENT_CONTAINER_DEFAULT_MARGIN,
}
